'use client';
import { ProductCardContext } from '.';
import { useCallback, useContext, useMemo } from 'react';
import { useIsVenueRouterPage } from '@/features/venue-router';
import { useGetPageUrl } from '@/schema/useGetPageUrl';
import { EventService } from '@/shared/lib/event-service';
import { ModalService } from '@/shared/ui/modal/ModalService';

export const useProductCardAction = () => {
    const {
        hash,
        slug,
        id,
        selectedVariantId,
        addToCartAction = 'addToCart',
    } = useContext(ProductCardContext);
    const getPageUrl = useGetPageUrl();
    const isVenueRouterPage = useIsVenueRouterPage();

    const detailHref = useMemo(() => {
        const url = getPageUrl('product-detail', { PRODUCT_SLUG: `${slug}-${hash}` });
        return selectedVariantId && selectedVariantId !== hash ? `${url}?variant=${selectedVariantId}` : url;
    }, [slug, hash, selectedVariantId, getPageUrl]);

    const trigger = useCallback(() => {
        switch (addToCartAction) {
            case 'viewDetail':
                EventService.trigger('product:view-detail', {
                    slug: `${slug}-${hash}`,
                    variantHash: selectedVariantId,
                });
                break;
            case 'selectVenue':
                ModalService.showPrefab('SelectVenueModal', {
                    availableForItemId: id,
                    allowSelectCurrent: isVenueRouterPage,
                });
                break;
            case 'addToCart':
            default:
                EventService.trigger('product:addons-menu:view-detail', {
                    productHash: hash,
                    initialVariant: selectedVariantId,
                });
        }
    }, [addToCartAction, hash, slug, selectedVariantId, id, isVenueRouterPage]);

    const href = addToCartAction === 'selectVenue' ? undefined : detailHref;

    return { trigger, href, addToCartAction };
};
